import Labelling from './labelling.component';

export default {
  Root: Labelling,
};
